import React from 'react';
import { SvgIcon } from '@mui/material';
import { Colors } from '../../../constants';
import CloseIcon from '@mui/icons-material/Close';

interface CloseButtonProps {
    onClose: () => void;
}

export default function CloseButton({ onClose }: CloseButtonProps) {
    return (
        <div
            style={{
                cursor: 'pointer',
            }}
            onClick={onClose}
        >
            <SvgIcon
                component={CloseIcon}
                viewBox="0 0 26 26"
                style={{
                    color: Colors.darkNavy,
                }}
            />
        </div>
    );
}
